import React from "react";

import "./Sponsor.css";

const sponsor = (props) => {
  const classes = "Sponsor " + props.sponsorType;
  return (
    <div className={classes}>
      <div className="imageContainer">
        <img src={props.img_src} alt={props.img_alt} />
      </div>

      <div>{props.children}</div>
    </div>
  );
};

export default sponsor;
